import { render, staticRenderFns } from "./EtudePatrimonialeForm.vue?vue&type=template&id=6c164d68&scoped=true&"
import script from "./EtudePatrimonialeForm.vue?vue&type=script&lang=js&"
export * from "./EtudePatrimonialeForm.vue?vue&type=script&lang=js&"
import style0 from "./EtudePatrimonialeForm.vue?vue&type=style&index=0&id=6c164d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c164d68",
  null
  
)

export default component.exports